module.exports = __webpack_public_path__ + "img/Delete-icon.4037e142.svg";